class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.codeCookieValue = this.getCookie('discount_code');

    // if (this.codeCookieValue && this.codeCookieValue === 'WELCOME-ORDERS-22') {
    //   this.getCheckoutCart();
    // }

    if (this.codeCookieValue && (this.codeCookieValue === 'WELCOME-SUBSCRIBERS-22' || this.codeCookieValue === 'WELCOME-ORDERS-22')) {
      this.showDiscountHint();
    }

  }

  showDiscountHint() {
    this.querySelector('.cart__discount-hint').classList.add('cart__discount-hint--show');
  }

  getCheckoutCart() {
    this.enableLoadingAll();
    fetch(window.location.href.replace('cart', 'checkout')).then(r=>r.text()).then(
      r => {
        const rawJSON = new DOMParser().parseFromString(r, 'text/html').getElementById('checkout-line-item-discount-allocations').innerHTML;
        const cartJSON = JSON.parse(rawJSON);
        this.parseDiscountAllocationLineItems(cartJSON);
      }
    )
  }

  parseDiscountAllocationLineItems(cartJSON) {
    this.querySelectorAll('.cart-item__price-wrapper').forEach(cartItem => {
      if (cartItem.getAttribute('data-line-item-line')) {
        const line = cartItem.getAttribute('data-line-item-line');
        const matchedObject = cartJSON.items.find(item => (parseInt(item.line) === parseInt(line)) && item.discount_allocations.find(alloc => alloc.title === this.codeCookieValue));
        if (matchedObject && Object.keys(matchedObject).length) {
          cartItem.innerHTML = matchedObject.template;
          document.querySelector(`[data-line-item-line-totals="${line}"]`).innerHTML = matchedObject.template;
          cartItem.closest(`#CartItem-${line}`).querySelector('.cart-item__quantity').innerHTML = '';
          document.querySelector(`[data-line-item-line-totals="${line}"]`).innerHTML = matchedObject.template;
          document.querySelector('[data-cart-total-price]').outerHTML = cartJSON.line_items_subtotal_price;
        }
      }
    });

    this.disableLoadingAll();
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split('; '+name+'=');
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    let quantityDiff;
    let itemDatalayer;

    try {
      itemDatalayer = JSON.parse(document.getElementById(`CartItem-${line}`).querySelector(`[data-item-data-layer]`).innerHTML);
      quantityDiff = quantity - itemDatalayer.quantity;
    } catch (error) { }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        if (quantityDiff != undefined && itemDatalayer != undefined) {
          if (quantityDiff > 0) {
            const addToCartEvent = new Event('add_to_cart');
            addToCartEvent.payload = itemDatalayer;
            addToCartEvent.payload.quantity = quantityDiff;
            document.dispatchEvent(addToCartEvent);
          } else if (quantityDiff < 0) {
            const removeFromCartEvent = new Event('remove_from_cart');
            removeFromCartEvent.payload = itemDatalayer;
            removeFromCartEvent.payload.quantity = quantityDiff * -1;
            document.dispatchEvent(removeFromCartEvent);
          }
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

        this.disableLoading();

        // if (this.codeCookieValue && this.codeCookieValue === 'WELCOME-ORDERS-22') {
        //   this.getCheckoutCart();
        // }

      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  enableLoadingAll() {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    document.querySelectorAll(`.cart-item__totals .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.querySelectorAll(`.loading-overlay-wrapper .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

  disableLoadingAll() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
    document.querySelectorAll(`.cart-item__totals .loading-overlay`).forEach((overlay) => overlay.classList.add('hidden'));
    document.querySelectorAll(`.loading-overlay-wrapper .loading-overlay`).forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);
